import programAgentDailyReport from './programAgentDailyReport';
import programAgentMonthlyReport from './programAgentMonthlyReport';

export default {
  dailyReport: programAgentDailyReport,
  monthlyReport: programAgentMonthlyReport,
};
